import { render, staticRenderFns } from "./AuditLog.vue?vue&type=template&id=520fc7c6&"
import script from "./AuditLog.vue?vue&type=script&lang=js&"
export * from "./AuditLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports